export enum CustomerServiceOfferingType {
  IceTryggFamilie = 'ICETRYGG_FAMILIE',
  IceTryggStandalone = 'ICETRYGG_STANDALONE',
}
